<template>
    <a-pagination v-model="Value" 
        show-size-changer show-quick-jumper 
        :hideOnSinglePage="true"
        :total="total" :pageSize="pageSize"
        :pageSizeOptions="PageSizeList"
        @showSizeChange="OnShowSizeChange" 
        @change="OnChange" />
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
            default: 1
        },
        total: {
            type: Number,
            default: 0
        },
        pageSize: {
            type: Number,
            default: 10
        }
    },
    data(){
        return {
            Value: this.value,
            PageSizeList: ["10", "15", "20", "25", "30", "50", "60", "70", "80", "90", "100"]
        }
    },
    watch: {
        value(){
            this.Value = this.value;
        },
        Value(){
            this.$emit("input",this.Value);
        }
    },
    methods: {
        OnShowSizeChange(current, size) {
            this.$emit("showSizeChange", current, size);
        },
        OnChange(current, size) {
            this.$emit("change", current, size);
        }
    }
}
</script>